/* eslint-disable import/prefer-default-export */
import { makeVar, useReactiveVar } from '@apollo/client'
import { useCallback } from 'react'

export type SelectRoadmapModalState = {
  opened: boolean
  onSelect: (id: string) => void
}

export type SelectRoadmapModalInputState = Omit<SelectRoadmapModalState, 'opened'>

const defaultModalState: SelectRoadmapModalState = {
  opened: false,
  onSelect: null,
}

const selectRoadmapModalHandler = makeVar<SelectRoadmapModalState>(defaultModalState)

export function useSelectRoadmapModalHandler() {
  const state = useReactiveVar(selectRoadmapModalHandler)

  const open = useCallback((opt?: SelectRoadmapModalInputState) => {
    selectRoadmapModalHandler({ opened: true, ...opt })
  }, [])

  const close = useCallback(() => {
    selectRoadmapModalHandler(defaultModalState)
  }, [])

  return { state, open, close }
}
